import { useMemo } from "react";
import { useCameras } from "@src/features/cameras";
import { useSelectedSiteStore } from "@src/stores/selected-site-store";
import { getCameraKeyString, isLegacyAppCamera } from "@src/utils/key-parser";

export function useSiteCameraKeys(siteId?: string) {
  const { data: cameras } = useCameras();
  const storedSiteId = useSelectedSiteStore((s) => s.selectedSiteId);
  const effectiveSiteId = siteId ?? storedSiteId;

  const supportedCameras = useMemo(() => {
    if (!cameras) return [];
    return cameras.filter((camera) => !isLegacyAppCamera(camera));
  }, [cameras]);

  const siteCameras = useMemo(() => {
    if (!effectiveSiteId) return [];
    return supportedCameras.filter((c) => c.site.id === effectiveSiteId);
  }, [supportedCameras, effectiveSiteId]);

  const cameraKeys = useMemo(() => {
    return siteCameras.map((c) => getCameraKeyString(c)).filter(Boolean);
  }, [siteCameras]);

  return { cameras, supportedCameras, siteCameras, cameraKeys, selectedSiteId: effectiveSiteId };
}
